// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__2xJld","avatar":"style_avatar__FI4-A","ant-popover-inner-content":"style_ant-popover-inner-content__3WDFe"};